const highlightBoxCSS = 'position: fixed; background: rgba(255, 235, 30, 0.4); border-radius: 4px; opacity: 0.2; pointer-events: none; z-index: 10000';

/**
 * 在页面上添加一个高亮的框框，0.5 秒后自动消失的那种
 * @param {null|undefined|{ left, top, width, height }} rect 可以取自 getBoundingClientRect()
 * @param continueTime 自定义持续时间默认0.5
 */
export function highlightRect(rect, continueTime = 500, overrideBackground = '', overrideShadow = '') {
  if (!rect) return;
  const {
    left,
    top,
    width,
    height
  } = rect;
  const highlightBox = document.createElement('div');
  highlightBox.setAttribute('style', `left: ${left}px; top: ${top}px; width: ${width}px; height: ${height}px;${highlightBoxCSS};transition: ${continueTime / 1e3}s`);
  if (overrideBackground) highlightBox.style.background = overrideBackground;
  document.body.appendChild(highlightBox);
  setTimeout(() => {
    highlightBox.style.opacity = 1;
    highlightBox.style.boxShadow = `0 0 0 3px ${overrideShadow || '#f30'}`;
    setTimeout(() => {
      highlightBox.style.opacity = 0.5;
      highlightBox.style.boxShadow = '';
      setTimeout(() => {
        document.body.removeChild(highlightBox);
      }, continueTime);
    }, Math.max(continueTime - 500, 200));
  }, 50);
}
//# sourceMappingURL=highlightRect.js.map
